import type { OrgEventStreamManager } from "@/hooks/org-event-stream-manager";
import { createContext } from "react";

/**
 * Provides the OrgEventStreamManager to the component tree.
 * null when the scoped-events feature flag is off.
 */
export const OrgEventStreamContext = createContext<OrgEventStreamManager | null>(null);
